import { cloneRecord, isRecord, stringField } from './record';
import type { ClientRequestId, LocalOptimisticMessage } from './types';

let clientRequestIdSequence = 0;

/** Creates a local client request id for optimistic send rows. */
export function createClientRequestId(): ClientRequestId {
  if (globalThis.crypto?.randomUUID) {
    // SAFETY: ClientRequestId is a branded string and randomUUID is the constructor for this local id space.
    return globalThis.crypto.randomUUID() as ClientRequestId;
  }

  clientRequestIdSequence += 1;
  // SAFETY: ClientRequestId is a branded string and this monotonic fallback is the constructor for this local id space.
  return `client-${clientRequestIdSequence}` as ClientRequestId;
}

/** Builds the stable engine item key for a local optimistic send. */
export function optimisticItemKey(clientRequestId: ClientRequestId): string {
  return `local:${clientRequestId}`;
}

/** Builds the legacy renderer-row shape carried by local optimistic messages. */
export function optimisticRendererRow(message: LocalOptimisticMessage, now: Date): Record<string, unknown> {
  const base = isRecord(message.rendererRow) ? cloneRecord(message.rendererRow) : {};
  return {
    ...base,
    id: stringField(base, 'id') ?? `optimistic_${message.clientRequestId}`,
    workspace_id: stringField(base, 'workspace_id') ?? message.workspaceId,
    channel_id: stringField(base, 'channel_id') ?? message.channelId,
    pseudotype: 'optimistic',
    optimistic_sort_order: message.clientRequestId,
    sort_order: message.clientRequestId,
    timestamp: Math.floor(now.getTime() / 1000),
    author_id: stringField(base, 'author_id') ?? message.authorId,
    author_type: stringField(base, 'author_type') ?? 'profile',
    text: stringField(base, 'text') ?? message.body,
    reactions: base.reactions ?? {}
  };
}
